// extracted by mini-css-extract-plugin
module.exports = {"aboutCenter":"aboutCenter--2KK1e","about_wrapper":"about_wrapper--1gwB5"};